import { render, staticRenderFns } from "./Speech.vue.js?vue&type=template&id=9c542822!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Speech.vue?vue&type=template&id=9c542822"
import script from "./Speech.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Speech.vue?vue&type=script&lang=js"
export * from "./Speech.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Speech.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports